<template>
    <v-layout class="fill-height">
        <v-flex xs12>
            <v-card height="86%" >
                <v-card-title class="accent white--text title">
                    Automated interface config editor
                </v-card-title>
                    <editor v-model="automatedConfig" @init="editorInit" lang="json" theme="chrome" width="100%" class="fill-height"></editor>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="accent"><v-icon small class="mr-2">fa-save</v-icon> Save</v-btn>
                </v-card-actions>

            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import editor from 'vue2-ace-editor'
    import {mapGetters} from 'vuex'
    export default {
        name: 'AutomatedConfigEditor',
        components: {editor},
        data() {
            return {
                automatedConfig:''
            }
        },
        methods: {
            ...mapGetters([
                'automatedViewsConfig',
            ]),
            editorInit: function () {
                require('brace/ext/language_tools') //language extension prerequsite...
                require('brace/mode/json')

                require('brace/theme/chrome')
            }
        },
        mounted () {
            this.automatedConfig=JSON.stringify(this.automatedViewsConfig(), null, 2);
        }
    }
</script>
